<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  components: { VuePerfectScrollbar },
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  mounted(){
    console.log(this.user)
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu();
    }
  }
};
</script>

<template>
  <!-- Topbar Start -->
  <div class="navbar-custom">
    <div class="container-fluid">
      <ul class="list-unstyled topnav-menu float-right mb-0">
        <li class="dropdown notification-list">
          <a class="navbar-toggle nav-link" @click="toggleMenu">
            <div class="lines">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </a>
        </li>

        <b-nav-item-dropdown right class="notification-list">
          <template slot="button-content">
            <i class="fe-bell noti-icon"></i>
            <span class="badge badge-danger rounded-circle noti-icon-badge">4</span>
          </template>

          <b-dropdown-text href="#" class="dropdown-item noti-title">
            <h5 class="m-0">
              <span class="float-right">
                <a href class="text-dark">
                  <small>Clear All</small>
                </a>
              </span>Notification
            </h5>
          </b-dropdown-text>

          <b-dropdown-text href="#" class="p-0">
            <VuePerfectScrollbar v-once class="notification-items">
              <a href="javascript:void(0);" class="dropdown-item notify-item active">
                <div class="notify-icon bg-soft-primary text-primary">
                  <i class="mdi mdi-comment-account-outline"></i>
                </div>
                <p class="notify-details">
                  Doug Dukes commented on Admin Dashboard
                  <small class="text-muted">1 min ago</small>
                </p>
              </a>
              <a href="javascript:void(0);" class="dropdown-item notify-item">
                <div class="notify-icon">
                  <img src="@assets/images/users/avatar-2.jpg" class="img-fluid rounded-circle" alt />
                </div>
                <p class="notify-details">Mario Drummond</p>
                <p class="text-muted mb-0 user-msg">
                  <small>Hi, How are you? What about our next meeting</small>
                </p>
              </a>

              <!-- item-->
              <a href="javascript:void(0);" class="dropdown-item notify-item">
                <div class="notify-icon">
                  <img src="@assets/images/users/avatar-4.jpg" class="img-fluid rounded-circle" alt />
                </div>
                <p class="notify-details">Karen Robinson</p>
                <p class="text-muted mb-0 user-msg">
                  <small>Wow ! this admin looks good and awesome design</small>
                </p>
              </a>

              <!-- item-->
              <a href="javascript:void(0);" class="dropdown-item notify-item">
                <div class="notify-icon bg-soft-warning text-warning">
                  <i class="mdi mdi-account-plus"></i>
                </div>
                <p class="notify-details">
                  New user registered.
                  <small class="text-muted">5 hours ago</small>
                </p>
              </a>
            </VuePerfectScrollbar>

            <a
              href="javascript:void(0);"
              class="dropdown-item text-center text-primary notify-item notify-all"
            >
              View all
              <i class="fi-arrow-right"></i>
            </a>
          </b-dropdown-text>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown right class="notification-list">
          <template slot="button-content">
            <div class="nav-user mr-0 waves-effect waves-light">
              <img src="@assets/images/users/avatar-1.jpg" alt="user-image" class="rounded-circle" />
              <span class="pro-user-name ml-1">
                {{ user ? user.name : '' }}
                <i class="mdi mdi-chevron-down"></i>
              </span>
            </div>
          </template>

          <router-link :to="{name:'profile'}">
            <b-dropdown-item href="/profile/">
              <i class="remixicon-account-circle-line"></i>
              <span>My Account</span>
            </b-dropdown-item>
          </router-link>

          <b-dropdown-item href="#">
            <i class="remixicon-wallet-line"></i>
            <span>
              My Wallet
              <span class="badge badge-success float-right">3</span>
            </span>
          </b-dropdown-item>

          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item href="/logout">
            <i class="remixicon-logout-box-line"></i>
            <span>Logout</span>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </ul>

      <!-- LOGO -->
      <div class="logo-box">
        <a href="/" class="logo text-center">
          <span class="logo-lg">
            <img src="@assets/images/logo.svg" alt height="20" />
            <!-- <span class="logo-lg-text-light">Xeria</span> -->
          </span>
          <span class="logo-sm">
            <!-- <span class="logo-sm-text-dark">X</span> -->
            <img src="@assets/images/logo-sm.png" alt height="24" />
          </span>
        </a>
      </div>

      <ul class="list-unstyled topnav-menu topnav-menu-left m-0">
        <router-link
          :to="{name:'home'}"
          tag="li"
          class="nav-link"
          style="cursor: pointer"
        >{{ $t('home') }}</router-link>
        <router-link :to="{name:'engine_overview'}" tag="li" class="nav-link" style="cursor: pointer">{{ $t('engine') }}</router-link>
        <router-link :to="{name:'wh_overview'}" tag="li" class="nav-link" style="cursor: pointer">{{ $t('way-home') }}</router-link>
        <router-link :to="{name:'radar_overview'}" tag="li" class="nav-link" style="cursor: pointer">{{ $t('radar') }}</router-link>
       <!--<router-link :to="{name:'vsat_overview'}" tag="li" class="nav-link" style="cursor: pointer">{{ $t('vsat') }}</router-link> -->
        <!-- <router-link :to="{name:'cloud_instances'}" tag="li" class="nav-link" style="cursor: pointer">{{ $t('cloud instances') }}</router-link> -->
        <li class="nav-link" style="cursor: pointer;"><a href="https://vikingo.org/community/">Сообщество</a></li>
        <!-- <li class="nav-link" style="cursor: pointer;"><a href="https://vikingo.org/community/blogs/">Блог</a></li> -->
        <!-- <router-link
          to="/"
          tag="li"
          class="nav-link"
          style="cursor: pointer"
        >{{ $t('vulnerabilities') }}</router-link>
        <router-link to="/" tag="li" class="nav-link" style="cursor: pointer">{{ $t('reports') }}</router-link> -->
      </ul>
    </div>
  </div>
  <!-- end Topbar -->
</template>

<style lang="scss">
.notification-items {
  height: 220px;
}
.ps > .ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
  width: 6px !important;
}
</style>
